/**************************************************
 * Nombre:       Tarjeta_Producto_Home
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Button, Grid, Typography} from "@mui/material";
import tmp_prod from '../../Recursos/Temporales/tmp_prod.png'
import tmp_prod_dos from '../../Recursos/Temporales/tmp_prod_dos.png'
import {useState} from "react";
import {Add} from '@mui/icons-material'
import {useResponsive} from "../../Modulo_responsive/Hooks/useResponsive";

const Tarjeta_Producto_Home = () => {
    const {sCell} = useResponsive()
    const [adentro, setAdentro] = useState(false);


    const click = (e) => {
        alert('boton')
        e.stopPropagation()
    }

    const clickImagen = (e) =>{
        alert('imagen')
        e.stopPropagation()
    }

    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}>

            <Grid
                onClick={(e) => clickImagen(e)}
                container
                justifyContent={'flex-start'}
                alignItems={'flex-end'}
                size={{xs: 12, sm: 12, md: 12}}
                onMouseOver={() => setAdentro(true)}
                onMouseLeave={() => setAdentro(false)}
                sx={{
                    backgroundImage: `url(${tmp_prod})`,
                    backgroundPosition: 'center',
                    backgroundSize: 'cover',
                    backgroundRepeat: 'no-repeat',
                    cursor: 'pointer',
                    '&:hover': {
                        backgroundImage: `url(${tmp_prod_dos})`,
                    },
                    height: sCell ? 150 : 250
                }}
            >


                    <Grid container size={{xs: 12, sm: 12, md: 12}}
                          sx={{
                              justifyContent: 'flex-start',
                              opacity: adentro ? 1 : 0,           // Controla la transparencia
                              visibility: adentro ? 'visible' : 'hidden', // Evita que se pueda hacer clic cuando está oculto
                              transition: 'opacity 0.6s ease-in-out, visibility 0.3s ease-in-out' // Duración y efecto de la animación
                          }}
                    >
                        <Button
                            onClick={(e) => click(e)}
                            startIcon={<Add/>}
                            fullWidth sx={{borderRadius: 0}}>Agregar al carrito</Button>
                    </Grid>



            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'center', mt: 2}}>
                <Typography sx={{textAlign: 'center', fontSize: sCell ? 14 : 16, fontWeight: 600, lineHeight: 1.2}}>
                    Gafas Rayban Round metal
                </Typography>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'center', mt: 0.5}}>
                <Typography sx={{textAlign: 'center', fontSize: 16, fontWeight: 400}}>
                    $ 150.000
                </Typography>
            </Grid>

        </Grid>
    )

}
export default Tarjeta_Producto_Home    